import type { InspoImportEntrySource } from '@/contexts/InspoImportContext';

export type InspoImportEntryChannel = 'share_sheet' | 'paste' | 'in_app_cta';

/**
 * Single attribution dimension for Inspo Import analytics.
 *
 * - **share_sheet** — Session opened via native OS share / Universal Link (`entry: deep_link`).
 * - **paste** — User ran the scraper via the in-app **Import** action (`source: manual`) while
 *   `entrySource` is `in_app` (typed/pasted URL or edited field then submitted). Set when `runImport`
 *   begins with `manual`, before the request finishes.
 * - **in_app_cta** — Everything else for `in_app` entry: opened from an in-app surface and only
 *   auto-imported a prefilled URL so far, or has not yet submitted manually.
 */
export function resolveInspoImportEntryChannel(
  entrySource: InspoImportEntrySource,
  hasUsedManualPasteSubmit: boolean,
): InspoImportEntryChannel {
  if (entrySource === 'deep_link') {
    return 'share_sheet';
  }
  if (hasUsedManualPasteSubmit) {
    return 'paste';
  }
  return 'in_app_cta';
}
